
export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
  },

  computed: {
    show() {
      return this.product?.variants?.length > 0
    },
  },

  methods: {
    dimension(product) {
      return `${product.dimension_unit} ${product.dimension_title}`
    },
  },
}
